import { render } from "./Artifact.vue?vue&type=template&id=effa4360&scoped=true"
import script from "./Artifact.vue?vue&type=script&lang=js"
export * from "./Artifact.vue?vue&type=script&lang=js"

import "./Artifact.vue?vue&type=style&index=0&id=effa4360&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-effa4360"]])

export default __exports__